module.exports = __webpack_public_path__ + "static/img/HLL.1359b0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/HLL.png
// module id = xYmC
// module chunks = 34